import { render } from "./LoadingLottie.vue?vue&type=template&id=9aadadc8"
import script from "./LoadingLottie.vue?vue&type=script&lang=js"
export * from "./LoadingLottie.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__